import React from "react";
import styled from "styled-components";

import PageWrap from "../components/PageWrap";
import SkeletonBox from "../components/SkeletonBox";

const StyledHeading = styled.h2`
  font-size: 1.25em;
  font-weight: bold;
`;

const StyledParagraph = styled.p`
  font-size: 1.125em;
  max-width: 90%;
  margin: 0 auto;
`;

const SuccessIcon = styled.img`
  width: 114px;
  display: inline-block;
  margin-right: 0.4em;
  margin-bottom: 0.95em;
`;

export default function ThankYou() {
  return (
    <PageWrap>
      <div>
        <SkeletonBox>
          <SuccessIcon alt="" src="/static/images/iconSecure-Success.svg" />
        </SkeletonBox>
        <SkeletonBox>
          <StyledHeading>Thank you!</StyledHeading>
        </SkeletonBox>
        <SkeletonBox>
          <StyledParagraph>
            Your document has been submitted securely.
            <br />
            <br />
            Please return to your Siebert online application to continue the
            sign-up process.
            <br />
            <br />
            You may now close this window.
          </StyledParagraph>
        </SkeletonBox>
      </div>
      <div> </div>
    </PageWrap>
  );
}
